import { Box } from '@mui/material';

export default function PageContainer({ children }) {
    return (
        <Box
            sx={{
                width: '100%',
                maxWidth: 1200,
                mx: 'auto',
                mt: 2,
                mb: 2,
                px: 2,
            }}
        >
            {children}
        </Box>
    );
} 